<script setup lang="ts">
import { CollapsibleContent } from 'radix-vue'
</script>

<template>
  <CollapsibleContent class="shared-ui-collapsible-content">
    <slot />
  </CollapsibleContent>
</template>

<style scoped>
.shared-ui-collapsible-content {
  overflow: hidden;
}
.shared-ui-collapsible-content[data-state='open'] {
  animation: slideDown 200ms ease-in-out;
}
.shared-ui-collapsible-content[data-state='closed'] {
  animation: slideUp 200ms ease-in-out;
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
}
</style>
